import classNames from "classnames/bind";
import * as React from "react";
import * as buttonStyles from "./newbutton.module.css";
import {getUrlWithTrailingSlash} from "../../utils/url";

const cx = classNames.bind(buttonStyles);

const NewButton = ({
    className,
    children,
    href,
    isLink,
    type,
    variant,
    disabled,
    icon,
    iconPosition,
    isActive,
    onClick,
    loading,
    external,
    ...other
}) => {
    const buttonsClasses = cx({button: true}, className);

    const internal = external !== undefined ? !external : isLink && /^\/(?!\/)/.test(href);
    const additionalProps = internal ? {} : {target: "_blank", rel: "noreferrer"};

    return isLink ? (
        <a
            href={getUrlWithTrailingSlash(href)}
            className={buttonsClasses}
            onClick={onClick}
            {...other}
            {...additionalProps}
        >
            {children}
            {icon && <span className={cx({button__icon: true})}>{icon}</span>}
        </a>
    ) : (
        <button
            className={buttonsClasses}
            disabled={disabled}
            type={type === "button" ? "button" : "submit"}
            onClick={onClick}
            {...other}
        >
            {children}
            {icon && <span className={cx({button__icon: true})}>{icon}</span>}
        </button>
    );
};

export default NewButton;
